export default __webpack_public_path__ + "static/media/recent_stories_pink.f8848420.png";